export class EmailConfig {
  smtp: string;
  port: number;
  userName: string;
  password: string;
  enableSsl: boolean;
  adminAddress: string;
  fromAddress: string;
  useDefaultDefaultCredentials: boolean;
  useTestAddressForOutgoingEmails: boolean;
  testEmailAddress: string;

  defaultAccountName: string;
  defaultPassword: string;
  defaultSmtp: string;
  defaultPort: number;
}

export class SupportConfig {
  emailAddress1: string;
  emailAddress2: string;
  emailAddress3: string;
  emailAddress4: string;
}

export class FailedAttemptsPassword {
  lokcsTypeAccount: number;
  unLokcsTypeAccount: number;
  maxInvalidPasswordAttempts: number;
  passwordAttemptWindow: number;
  intervalInSeconds: number;
}

export class ValidCharacterseSettings {
  lowercase: boolean;
  uppercase: boolean;
  digits: boolean;
  punctuation: boolean;
}

export class UserPasswordSettings {
  passwordReuse: number;
  validCharacters: ValidCharacterseSettings;
  lastPasswordsNumber: number;
  minPasswordLength: number;
  autocomplete: boolean;
}

export class UserSessionSettings {
  idleTime: number;
  idleTimeEnabled: boolean = false;
}

export class ReCaptchaSettings {
  siteKey: string;
  secretKey: string;
  apiLink: string;
}

export class S3Settings {
  accessKeyID: string;
  secretAccessKey: string;
  awsRegion: string;
  bucketName: string;
}

export class MaintenanceSettings {
  option: MaintenanceOptions;
  start: Date;
  end: Date;
  message: string;
  isActive: boolean;
  externalApiUrl: string;
}

export class SystemSetting {
  id: number;
  name: string;
  value: string;
  lastUpdateDate: Date;
}

export enum MaintenanceOptions {
  Basic = 0,
  External = 1,
}

export class AppConfig {
  email: EmailConfig;
  support: SupportConfig;
  failedAttemptsPassword: FailedAttemptsPassword;
  userPasswordSettings: UserPasswordSettings;
  userSessionSettings: UserSessionSettings;
  reCaptchaSettings: ReCaptchaSettings;
  s3Settings: S3Settings;
  maintenanceSettings: MaintenanceSettings;
}

export class HangfireSet {
  jobId: string;
  jobMetadata: string;
  cron: number;
  timeZoneId: string;
  queue: string;
  createdAt: Date;
  nextExecution: Date;
  lastExecution: Date;
  lastJobId: string;
}

export class HangfireJob {
  id: number;
  jobName: string;
  stateName: string;
  invocationData: string;
  arguments: string;
  createdAt: Date;
  expireAt: Date;
}

export class HangfireJobState {
  id: number;
  jobId: number;
  name: string;
  reason: string;
  createdAt: Date;
  data: string;

  metadata: any;
  job: HangfireJob;
}

export class SystemDateTimeInfo {
  local: string;
  utc: string;
  culture: string;
  timeZone: string;
}
